module.exports = __webpack_public_path__ + "img/CheckIcon.52685622.svg";